/* Houndfield: tiny, dependency-free helpers (loaded with defer from layout/theme.liquid).
   Background videos ([data-hf-video-root]):
   - load only on screens >= 768px and only when the visitor hasn't asked for reduced motion
     (phones get the still image only, which keeps LCP fast and saves data)
   - the <source> starts as data-src, so nothing downloads until we decide to play
   - play only while on screen (IntersectionObserver), pause otherwise
   - a missing/broken file hides the video layer and leaves the still image / brand background
   - an optional pause/play button ([data-hf-video-toggle]) for WCAG 2.2.2 */
(function () {
  'use strict';
  var desktop = window.matchMedia('(min-width: 768px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function onChange(mq, fn) {
    if (mq.addEventListener) mq.addEventListener('change', fn);
    else if (mq.addListener) mq.addListener(fn);
  }

  function setupRoot(root) {
    if (root.dataset.hfReady) return;
    root.dataset.hfReady = '1';
    var video = root.querySelector('video[data-hf-video]');
    var toggle = root.querySelector('[data-hf-video-toggle]');
    if (!video) return;
    var loaded = false;
    var inView = false;
    var userPaused = false;

    root.classList.add('hf-media--js');

    function allowed() {
      return desktop.matches && !reduce.matches;
    }
    function fail() {
      root.classList.add('hf-media--video-failed');
      root.classList.remove('hf-media--playing');
    }
    function load() {
      if (loaded) return;
      loaded = true;
      var sources = video.querySelectorAll('source[data-src]');
      if (!sources.length) { fail(); return; }
      for (var i = 0; i < sources.length; i++) {
        sources[i].addEventListener('error', fail);
        sources[i].src = sources[i].dataset.src;
      }
      video.load();
    }
    function setToggle() {
      // The button reflects the visitor's choice only (pausing because the section scrolled away doesn't count).
      root.classList.toggle('hf-media--paused', userPaused);
      if (!toggle) return;
      toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      toggle.setAttribute('aria-label', userPaused ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
    }
    function sync() {
      var on = allowed();
      root.classList.toggle('hf-media--video-off', !on);
      if (on && inView && !userPaused) {
        load();
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } else if (!video.paused) {
        video.pause();
      }
      setToggle();
    }

    video.addEventListener('playing', function () { root.classList.add('hf-media--playing'); setToggle(); });
    video.addEventListener('error', fail);

    if (toggle) {
      toggle.addEventListener('click', function () {
        userPaused = !userPaused;
        sync();
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        sync();
      }, { rootMargin: '200px 0px' }).observe(root);
    } else {
      inView = true;
    }
    onChange(desktop, sync);
    onChange(reduce, sync);
    sync();
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-hf-video-root]');
    for (var i = 0; i < roots.length; i++) setupRoot(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Theme editor: re-init sections when they're added or re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
